import { PanelLeftIcon, PanelRightIcon } from 'lucide-react';

import { DimeActionToolbar } from '../DimeActionToolbar/DimeActionToolbar.js';
import { DimeActionToolbarToggle } from '../DimeActionToolbar/DimeActionToolbarToggle.js';
import type { DimeDetailLayoutToolbar as ToolbarConfig } from './DimeDetailLayout.types.js';

type DimeDetailLayoutActionBarProps = Readonly<{
  toolbar: ToolbarConfig;
  /** Folds secondary actions into More and docks the bar at the bottom, in thumb reach. */
  mobile: boolean;
  leftPaneTitle?: string;
  leftPaneOpen: boolean;
  leftPanePressed: boolean;
  onToggleLeftPane: () => void;
  showRightPaneToggle: boolean;
  rightPaneOpen: boolean;
  onToggleRightPane: () => void;
}>;

export function DimeDetailLayoutActionBar({
  toolbar,
  mobile,
  leftPaneTitle,
  leftPaneOpen,
  leftPanePressed,
  onToggleLeftPane,
  showRightPaneToggle,
  rightPaneOpen,
  onToggleRightPane,
}: DimeDetailLayoutActionBarProps) {
  return (
    <DimeActionToolbar
      {...toolbar}
      compact={mobile}
      className={
        mobile
          ? 'justify-between border-t border-b-0 pb-[max(0.25rem,env(safe-area-inset-bottom))]'
          : undefined
      }
      leftRail={
        leftPaneTitle ? (
          <DimeActionToolbarToggle
            icon={<PanelLeftIcon />}
            label={leftPaneTitle}
            pressed={leftPanePressed}
            aria-expanded={leftPaneOpen}
            onPressedChange={onToggleLeftPane}
          />
        ) : undefined
      }
      rightRail={
        showRightPaneToggle ? (
          <DimeActionToolbarToggle
            icon={<PanelRightIcon />}
            label={rightPaneOpen ? 'Hide Details' : 'Show Details'}
            pressed={rightPaneOpen}
            onPressedChange={onToggleRightPane}
          />
        ) : undefined
      }
    />
  );
}
